import { graphql } from "./generated/index.js"

// Queries ======================================================================

export const fetchSchemaById = graphql(`
  query fetchSchemaById($id: Int!) {
    schema: schemas_by_pk(id: $id) {
      ...SchemaFields
    }
  }
`)

// How many records, lists and types reference a schema. Lists point at a schema
// through `data.listing_schema_id`; records through `schema_id`; types through
// their default `schema_id`.
export const fetchSchemaUsage = graphql(`
  query fetchSchemaUsage($id: Int!) {
    records_aggregate(where: { schema_id: { _eq: $id } }) {
      aggregate {
        count
      }
    }
    lists: records(
      where: { type: { _eq: "list" }, data: { _contains: { listing_schema_id: $id } } }
      order_by: { name: asc }
    ) {
      id
      name
    }
    types(where: { schema_id: { _eq: $id } }, order_by: { name: asc }) {
      name
    }
  }
`)

// Mutations ====================================================================

export const insertSchema = graphql(`
  mutation insertSchema($object: schemas_insert_input!) {
    insert_schemas_one(object: $object) {
      ...SchemaFields
    }
  }
`)

export const updateSchema = graphql(`
  mutation updateSchema($id: Int!, $_set: schemas_set_input!) {
    update_schemas_by_pk(pk_columns: { id: $id }, _set: $_set) {
      ...SchemaFields
    }
  }
`)

export const deleteSchema = graphql(`
  mutation deleteSchema($id: Int!) {
    delete_schemas_by_pk(id: $id) {
      ...SchemaFields
    }
  }
`)

